<template>
    <div>
        <header class="page-header">
            <h2>
                <a href="/dashboard"><i class="fas fa-tachometer-alt"></i></a>
            </h2>
        </header>

        <div class="card card-dashboard">
            <div class="card-body" v-if="loading">
                Cargando...
            </div>

            <div class="card-body" v-else>
                <div class="mb-2">
                    <span class="badge"
                        :class="record.priority === 'critical' ? 'badge-danger' : (record.priority === 'warning' ? 'badge-warning' : 'badge-info')">
                        {{ record.event_type === 'announcement' ? 'Aviso' : 'Actualización' }}
                    </span>
                    <small class="text-muted ml-2">{{ record.created_at }}</small>
                </div>

                <h4 class="font-weight-bold">{{ record.title }}</h4>

                <p class="mb-0" style="white-space: pre-line;">{{ record.message }}</p>
            </div>

            <div class="card-footer text-right">
                <a href="/dashboard" class="btn btn-sm btn-primary">Volver</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        communicationId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            loading: false,
            record: {}
        }
    },
    created() {
        this.loadRecord()
    },
    methods: {
        loadRecord() {
            this.loading = true
            this.$http.get(`/dashboard/communications/${this.communicationId}/record`)
                .then((response) => {
                    if (response.data.success) {
                        this.record = response.data.data || {}
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        }
    }
}
</script>


// WEBPACK FOOTER //
// modules/Dashboard/Resources/assets/js/views/communication_show.vue